import React from 'react';
import PropTypes from 'prop-types';

export class Step extends React.Component {
  static propTypes = {
    children: PropTypes.any,
    goBackward: PropTypes.func,
    goForward: PropTypes.func,
  };

  goBackward = () => {
    if (this.props.goBackward) {
      return this.props.goBackward();
    }
    return true;
  };

  goForward = () => {
    if (this.props.goForward) {
      return this.props.goForward();
    }
    return true;
  };

  render() {
    const content = React.cloneElement(this.props.children, this.props);
    return <div>{content}</div>;
  }
}
